import { render, staticRenderFns } from "./WelfareClaims.vue?vue&type=template&id=5b8d05f7&"
import script from "./WelfareClaims.vue?vue&type=script&lang=js&"
export * from "./WelfareClaims.vue?vue&type=script&lang=js&"
import style0 from "./WelfareClaims.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports